"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const webview_app_1 = require("@/webview_app");
const functions_1 = require("@/common/functions");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DeliverySettingAddress_1 = require("@/common/components/DeliverySetting/DeliverySettingAddress");
const _1 = require(".");
function default_1({ deliverySettingData, setDeliverySettingData, addressList, fetchAddressList, open, closeDialog, isPaymentDetail, }) {
    const [isInputMode, setIsInputMode] = (0, react_1.useState)(false);
    const enableInputMode = () => setIsInputMode(true);
    const disableInputMode = () => setIsInputMode(false);
    const [isManageAddressInProgress, setIsManageAddressInProgress] = (0, react_1.useState)(false);
    const onDialogBackOrClose = () => {
        if (!isManageAddressInProgress) {
            if (isInputMode)
                disableInputMode();
            else
                closeDialog();
        }
    };
    (0, webview_app_1.useAABBDialogClose)({
        open,
        closeDialog: onDialogBackOrClose,
        additionalDeps: [isInputMode, isManageAddressInProgress],
        dialogName: 'manage-address',
    });
    (0, functions_1.useIOSDialogCloseScrollBack)(open);
    const { user_id: userId, region, default_delivery: activeDelivery, room_second_custom, } = deliverySettingData;
    const isRegionKR = region === 'KR';
    const needEnAddress = Boolean(isRegionKR && (!isPaymentDetail || room_second_custom));
    const addressListLength = addressList.length;
    const hasNoAddress = !addressListLength;
    const hasOnlyAddress = addressListLength === 1;
    const isOnlyAddressDefault = hasOnlyAddress && addressList[0].is_default;
    const hasMaximumAddressList = addressListLength >= 5;
    const defaultValues = { phone_code: '+82' };
    const manageAddressForm = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        defaultValues,
    });
    const managingAddressId = manageAddressForm.watch('id');
    const [isEditMode, setIsEditMode] = (0, react_1.useState)(false);
    const isDefaultCheckDisabled = isEditMode ? isOnlyAddressDefault : hasNoAddress;
    const enableAddNewAddress = () => {
        enableInputMode();
        manageAddressForm.reset(Object.assign(Object.assign({}, defaultValues), { is_default: hasNoAddress }));
        setIsEditMode(false);
    };
    const enableEditAddress = (data) => {
        enableInputMode();
        const phoneNumber = data.phone.replace(/[^0-9]/g, '');
        manageAddressForm.reset(Object.assign(Object.assign({}, data), { phone: phoneNumber }));
        setIsEditMode(true);
    };
    (0, react_1.useEffect)(() => {
        if (hasNoAddress && !isPaymentDetail) {
            closeDialog();
        }
    }, [hasNoAddress, isPaymentDetail]);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: open, fullScreen: maxWidth768, PaperProps: {
            sx: {
                width: maxWidth768 ? '100%' : '480px',
                height: maxWidth768 ? '100%' : '90vh',
                borderRadius: 0,
                margin: 0,
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(_1.ManageAddressHeader, { isInputMode: isInputMode, onDialogBackOrClose: onDialogBackOrClose }), !isInputMode && ((0, jsx_runtime_1.jsx)(_1.AddNewAddressButton, { hasMaximumAddressList: hasMaximumAddressList, enableAddNewAddress: enableAddNewAddress })), !isInputMode ? ((0, jsx_runtime_1.jsx)(_1.ManageAddressList, { addressList: addressList, enableEditAddress: enableEditAddress, isRegionKR: isRegionKR, needEnAddress: needEnAddress, activeDelivery: activeDelivery, setDeliverySettingData: setDeliverySettingData, fetchAddressList: fetchAddressList, closeDialog: closeDialog, isPaymentDetail: isPaymentDetail })) : ((0, jsx_runtime_1.jsx)(DeliverySettingAddress_1.DeliverySettingChangeAddress, { settingAddressForm: manageAddressForm, isRegionKR: isRegionKR, needEnAddress: needEnAddress, isEditMode: isEditMode, isManageAddressDialog: true })), isInputMode && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(_1.ManageAddressDefaultCheck, { manageAddressForm: manageAddressForm, isDefaultCheckDisabled: isDefaultCheckDisabled }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                            display: 'flex',
                            columnGap: '10px',
                            width: '100%',
                            padding: '12px 16px 32px',
                        } }, { children: [isEditMode && ((0, jsx_runtime_1.jsx)(_1.ManageAddressDeleteButton, { userId: userId, managingAddressId: managingAddressId, isManageAddressInProgress: isManageAddressInProgress, setIsManageAddressInProgress: setIsManageAddressInProgress, disableInputMode: disableInputMode, fetchAddressList: fetchAddressList })), (0, jsx_runtime_1.jsx)(_1.ManageAddressSaveButton, { userId: userId, managingAddressId: managingAddressId, isManageAddressInProgress: isManageAddressInProgress, setIsManageAddressInProgress: setIsManageAddressInProgress, manageAddressForm: manageAddressForm, hasNoAddress: hasNoAddress, isEditMode: isEditMode, disableInputMode: disableInputMode, fetchAddressList: fetchAddressList })] }))] }))] })));
}
exports.default = default_1;
